/** True when the user is in the practice hub via /dashboard (not /practices). */
export const isFromPracticeDashboard = (location) =>
  Boolean(location?.pathname?.startsWith('/dashboard') || location?.state?.fromDashboard);

/** Query flag used to open the add-patient modal from sidebar navigation. */
export const ADD_PATIENT_QUERY_FLAG = 'addPatient';

/** Resolve the active practice id from the user record or /practices/:id routes. */
export const resolvePracticeIdFromUserOrPath = (user, pathname = '') => {
  if (user?.practice_id) return String(user.practice_id);
  const match = String(pathname).match(/^\/practices\/(\d+)/);
  return match ? match[1] : null;
};

/** True on the practice hub page — sidebar Dashboard stays selected for any in-page tab. */
export const isPracticeHubRoute = (pathname) =>
  /^\/practices\/\d+$/.test(pathname) ||
  pathname === '/dashboard' ||
  pathname === '/provider-dashboard';

/** @deprecated Use isPracticeHubRoute — kept for callers that pass search (ignored). */
export const isPracticeDetailsDashboardRoute = (pathname) => isPracticeHubRoute(pathname);

/** Navigate target that opens the patient tab and triggers the add-patient modal. */
export const getAddPatientModalNavigationTarget = (user, pathname = '') => {
  const roleId = Number(user?.role_id);
  const practiceId = resolvePracticeIdFromUserOrPath(user, pathname);

  if (roleId === 4 || roleId === 5) {
    return `/dashboard?tab=patient&${ADD_PATIENT_QUERY_FLAG}=1`;
  }

  if (practiceId) {
    return `/practices/${practiceId}?tab=patient&${ADD_PATIENT_QUERY_FLAG}=1`;
  }

  return `/dashboard?tab=patient&${ADD_PATIENT_QUERY_FLAG}=1`;
};

/** Append fromDashboard=true so Event Logs can link back to /dashboard routes. */
export const appendFromDashboardQuery = (url, location) => {
  if (!isFromPracticeDashboard(location)) return url;
  return url.includes('?') ? `${url}&fromDashboard=true` : `${url}?fromDashboard=true`;
};

/** Practice hub tab URL — /dashboard/:id or /practices/:id */
export const getPracticeHubPath = (practiceId, tabId, fromDashboard) => {
  const base = fromDashboard ? '/dashboard' : '/practices';
  return `${base}/${practiceId}?tab=${tabId}`;
};

/** Patients tab URL — preserves active program (CCM/RPM) when returning from patient detail. */
export const buildPracticePatientTabPath = (practiceId, { fromDashboard, program } = {}) => {
  const base = fromDashboard ? '/dashboard' : '/practices';
  const params = new URLSearchParams();
  params.set('tab', 'patient');
  const normalizedProgram = String(program || '').trim().toLowerCase();
  if (normalizedProgram) {
    params.set('program', normalizedProgram);
  }
  if (fromDashboard) {
    params.set('fromDashboard', 'true');
  }
  return `${base}/${practiceId}?${params.toString()}`;
};
